import type { PortfolioStateItem } from 'global/Securities/types/store/portfolio';

interface PortfolioItem extends PortfolioStateItem {
  type_label?: string;
}

export const getCombinedPortfolioList = (
  dataRegular: Partial<PortfolioStateItem>[] = [],
  dataDaytrade: Partial<PortfolioStateItem>[] = [],
  isRealTrading = false,
  dataBonds: Partial<PortfolioStateItem[]> = [],
): Partial<PortfolioItem>[] => {
  if (!isRealTrading) {
    return dataRegular;
  }

  const regular =
    dataRegular?.map((item) => ({
      ...item,
      type_label: 'RG',
    })) || [];

  const daytrade =
    dataDaytrade?.map((item) => ({
      ...item,
      type_label: 'DT',
    })) || [];

  const bonds = dataBonds?.map((item) => ({
    ...item,
    type_label: 'FR',
  }));

  return [...daytrade, ...regular, ...bonds];
};

type GetPortfolioTypeReturn =
  | 'Regular'
  | 'Day Trade'
  | 'Bonds'
  | 'Both'
  | 'None';

export const getPortfolioType = (
  portfolios: Partial<PortfolioItem>[],
): GetPortfolioTypeReturn => {
  const isRegular = portfolios?.some((item) => item.type_label === 'RG');
  const isDayTrade = portfolios?.some((item) => item.type_label === 'DT');
  const isBonds = portfolios?.some((item) => item.type_label === 'FR');

  if (isRegular && isDayTrade) {
    return 'Both';
  }

  if (isRegular) {
    return 'Regular';
  }

  if (isDayTrade) {
    return 'Day Trade';
  }

  if (isBonds) {
    return 'Bonds';
  }

  return 'None';
};

export const getUnavailableReason = (
  isTimeLimit: boolean,
  isSellOrder: boolean,
  isSellAmend: boolean,
  time: string,
): string => {
  if (!isTimeLimit || (isTimeLimit && isSellAmend)) {
    return 'Aset Day Trade sedang dalam proses penjualan otomatis';
  }

  const orderType = isSellOrder ? 'Penjualan' : 'Pembelian';
  return `${orderType} saham-saham Day Trade hanya dapat dilakukan pukul ${time} WIB.`;
};

interface GetDayTradeUIValueReturn {
  color: string;
  percentColor: string;
  background: string;
  label: string;
}

export const getDayTradeUIValue = (
  percentRatio: number,
  forceSellLimit: number,
  cautionLimit: number,
): GetDayTradeUIValueReturn => {
  if (percentRatio > forceSellLimit) {
    return {
      color: '#EE4A49',
      percentColor: '#EE4A49',
      background: '#FBDFDF',
      label: 'FORCE SELLING',
    };
  }

  if (percentRatio > cautionLimit) {
    return {
      color: '#F5931B',
      percentColor: '#F5931B',
      background: '#FDE7CD',
      label: 'CAUTION',
    };
  }

  return {
    color: '#333333',
    percentColor: '#00AB6B',
    background: '#CCEEE1',
    label: '',
  };
};
